import { render, staticRenderFns } from "./BubblePackChart.vue?vue&type=template&id=6fbbb0b1&"
import script from "./BubblePackChart.vue?vue&type=script&lang=js&"
export * from "./BubblePackChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports